import styled from 'styled-components';
export const Container = styled.div `
  position: relative;
`;
export const ActivityIndicatorWrapper = styled.div `
  position: absolute;
  top: calc(var(--space-50) * -1);
  right: calc(var(--space-50) * -1);
`;
